<template>
    <el-select id="attnSelectorInput" :value="value" class="select" :placeholder="$t('shared.pleaseSelectATTN')" v-bind:disabled="disabled" @change="$emit('input', $event)">
        <el-option v-for="item in attns" :key="item.id" :label="item.name" :value="item.id"></el-option>
    </el-select>
</template>

<script>
    export default {
        name: 'attn-selector',
        props: ['value', 'disabled', 'attns'],
        data() {
            return {
                loading: false
            }
        }
    }
</script>

<style scoped>
    .select {
        width: 100%;
    }
</style>


// WEBPACK FOOTER //
// ClientApp/app/shared/components/AttnSelector.vue